<template>
  <div>
    <div v-if="url" class="prism-player" :id="videoID"></div>
    <div v-if="!url" :style="{height: height}">
      <el-empty :image-size="80" description="无视频接入"></el-empty>
    </div>
  </div>
</template>

<script>
  import {guid} from "../util/string.util"
  export default {
    props: {
      url: {
        type: String,
        default: '',
      },
      startToPlay: {
        type: Boolean,
        default: false,
      },
      height: {
        type: String,
        default: '200px',
      }
    },
    data() {
      return {
        videoID: "",
        player: null,
      };
    },
    watch: {
      url(val) {
        this.$nextTick(() => {
          if (this.url) {
            this.startPlay(this.url);
          }
        });
      }
    },
    created(){
      this.videoID = "vid" + guid().substring(0, 20);
    },
    mounted() {
      this.$nextTick(() => {
        if (this.url) {
          this.startPlay(this.url);
        }
      });
    },
    methods: {
      startPlay(url) {
        let $this = this;
        this.player = new Aliplayer({
            id: this.videoID,
            format: "m3u8",
            source: url,
            width: "100%",
            height: $this.height,
            autoplay: false,
            isLive: true
          },
          function (player) {
            if ($this.startToPlay) {
              setTimeout(()=>{
                player.play();
              }, 200)
            }
          }
        );
      }
    },
    destroyed() {
      if (this.player) {
        this.player.dispose();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/video/AliPlayerVideo.vue